import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { HashRouter } from 'react-router-dom';
import { AuthProvider } from 'tradesoft-ng-auth'

const authConfig = {
  clientId: 'ata.xhcp',
  clientSecret : '1ea76566c212450faa4c3c8459e71f4f',
  tokenEndpoint: process.env.REACT_APP_TOKEN_ENDPOINT ?? "",
  verifyEndpoint:  "https://xhcpauth.atayatirim.com.tr/auth/verifytoken",
  scope: 'authlevel2',
  redirectUri: 'https://react.atayatirim.com.tr/xhcpstatics/'
}

const root = ReactDOM.createRoot(document.getElementById('root'));
if(localStorage.getItem("tema")!==null){
  document.body.classList.add(localStorage.getItem("tema"));
}

root.render(
  // <AuthProvider authConfig={authConfig}>
   <HashRouter>
     <App />
   </HashRouter>
  // </AuthProvider>
);